/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog/dialog.component';
import { DialogInsertionDirective } from './dialog-insertion.directive';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@NgModule({
  imports: [CommonModule, DialogModule, ButtonModule],
  exports: [DialogInsertionDirective],
  declarations: [DialogComponent, DialogInsertionDirective],
})
export class ConfirmationDialogModule {}
